import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

import { ModelOfContrato, ModelOfFuelType, ModelOfTipoCombustivel } from '../../database';
import api from '../../services/api';

const initialValuesOfContrato = {
	ORGAO: '',
	ID: '',
	DATAINICIO: '',
	DATAFIM: '',
	NUMERO: '',
	TAXAADM: 0,
	DESCRICAO: '',
	VALOR: 0,
};

export const useListContratosController = () => {
	const [ContratosData, setContratosData] = useState<ModelOfContrato[]>([]);
	const [selectedContrato, setSelectedContrato] = useState<ModelOfContrato>(initialValuesOfContrato);
	const [loading, setLoading] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const toast: any = useRef();
	const { userAgencyId } = useAuth();


	const validationSchema = Yup.object().shape({
		ID: Yup.string(),
		ORGAO: Yup.string(),
		DATAINICIO: Yup.string(),
		DATAFIM: Yup.string(),
		NUMERO: Yup.string(),
		TAXAADM: Yup.number(),
		DESCRICAO: Yup.string(),
		VALOR: Yup.number().nullable(),
	});

	const getContratos = () => {
		setLoading(true);

		api.get(`/contratos2/${userAgencyId}`)
			.then(response => {

				if (response.status === 204) {
					setLoading(false);
				} else {
					console.log("response ---", response)
					setContratosData(
						ContratosData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);
					setLoading(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeContrato = async (Contrato: ModelOfContrato) => {
		setLoading(true);
		api.delete(`contratos/${Contrato.ID}`)
			.then(response => {
				const newList = ContratosData.filter(creditor => creditor.ID !== response.data.ID);
				setContratosData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O credor foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getContratos();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editContrato = async (Contrato: ModelOfContrato) => {
		setLoadingEdit(true);
		const editedContrato: ModelOfContrato = {
			...Contrato,
		};
		api.put(`contratos/${selectedContrato?.ID}`, editedContrato)
			.then(() => {
				getContratos();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O credor foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getContratos();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação! ' + err,
					life: 5000,
				});
			});
	};



	const openDeleteDialog = (Contrato: ModelOfContrato) => {
		setDeleteDialog(true);
		setSelectedContrato(Contrato);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Contrato: ModelOfContrato) => {
		setEditDialog(true);
		setSelectedContrato(Contrato);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};


	const formik = useFormik<ModelOfContrato>({

		initialValues: {
			ORGAO: '',
			ID: '',
			DATAINICIO: '',
			DATAFIM: '',
			NUMERO: '',
			TAXAADM: 0,
			DESCRICAO: '',
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			console.log("valores: ", values)
			await editContrato(values)
		}

	});



	useEffect(() => {
		getContratos();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		getContratoListController: {
			formik,
			ContratosData,
			selectedContrato,
			loading,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
		},
		handleContratoListController: {
			removeContrato,
			editContrato,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getContratos,
		},
	};
};
